// Diagnostic-context collection for support tickets (Story #4613, Stream 8a).
// The chips shown under "Diagnostic context" and sent with a request. Everything
// here is derived from the browser only — no PII beyond what the user is already
// looking at (the current path + portal + app version + UA-derived browser/OS).

import { SUPPORT_PORTAL_LABEL } from '../constants/support'

export interface DiagnosticContext {
  portal: string
  page: string
  version: string
  browser: string
  /** all fields are strings — index signature lets this satisfy the API body type */
  [k: string]: string
}

function detectBrowserOs(ua: string): string {
  let browser = 'Browser'
  const m = ua.match(/(Edg|Chrome|Firefox|Safari)\/(\d+)/)
  if (m) {
    const name = m[1] === 'Edg' ? 'Edge' : m[1]
    browser = `${name} ${m[2]}`
  }
  let os = ''
  if (/Windows NT 10/.test(ua)) os = 'Windows'
  else if (/Windows/.test(ua)) os = 'Windows'
  else if (/Mac OS X/.test(ua)) os = 'macOS'
  else if (/Android/.test(ua)) os = 'Android'
  else if (/iPhone|iPad/.test(ua)) os = 'iOS'
  else if (/Linux/.test(ua)) os = 'Linux'
  return os ? `${browser} · ${os}` : browser
}

export function collectDiagnostics(): DiagnosticContext {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
  const version =
    (typeof window !== 'undefined' && window.INNOVATEFLOW_CONFIG?.VERSION) || 'unknown'
  const page = typeof window !== 'undefined' ? window.location.pathname : ''
  return {
    portal: SUPPORT_PORTAL_LABEL,
    page,
    version,
    browser: detectBrowserOs(ua),
  }
}
